<p-dialog [modal]="true" [(visible)]="visible">
    <ng-template pTemplate="header">
        <span class="p-dialog-title">
            Allocate goods for {{ forecast.planningParameter.name }} on {{ forecast.year }}-{{ forecast.month | number: '2.0' }}
        </span>
    </ng-template>

    <div class="grid">
        <div class="col-6">
            <p-fluid>
                @for (subsidiary of (subsidiaries$ | async)?.getSubsidiaries(); track subsidiary) {
                    <div class="field">
                        <label for="{{ subsidiary.id }}">{{ subsidiary.name }}
                            @if (hasAllocation(subsidiary.id)) {
                                <small>(Currently allocated : {{ allocatedQuantitiesBeforeChange[subsidiary.id] }})</small>
                            }
                        </label>
                        <p-inputNumber
                            [(ngModel)]="allocatedQuantities[subsidiary.id]"
                            [showButtons]="true"
                            buttonLayout="horizontal"
                            inputId="{{ subsidiary.id }}"
                            [step]="1"
                            mode="decimal"
                        >
                            <ng-template #incrementbuttonicon>
                                <span class="pi pi-plus"></span>
                            </ng-template>
                            <ng-template #decrementbuttonicon>
                                <span class="pi pi-minus"></span>
                            </ng-template>
                        </p-inputNumber>
                    </div>
                }
            </p-fluid>
        </div>
    </div>

    <ng-template #footer>
        <p-button label="Cancel" [text]="true" severity="secondary" (click)="closeModal()" />
        <p-button label="Save" [outlined]="true" severity="success" (click)="updateForecastAllocation()" />
    </ng-template>
</p-dialog>
